/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  return typeof str === 'string' || str instanceof String
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * 验证是否为弱密码 true: 弱密码, false: 强密码
 * @param pwd
 * @returns {boolean}
 */
export function isWeakPasswords(pwd) {
  const reg =
    /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/g
  const arr = [
    '00000',
    '11111',
    '22222',
    '33333',
    '44444',
    '55555',
    '66666',
    '77777',
    '88888',
    '99999',
    '12345',
    '67890',
    'qwer',
    'asdf',
    '1qaz',
    '2wsx',
    '3edc',
  ]
  for (var i = 0; i < arr.length; i++) {
    if (pwd.indexOf(arr[i]) !== -1) {
      return true
    }
  }
  return !reg.test(pwd)
}

// 校验身份证
export function validID(value) {
  return /(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(value)
}
// 校验统一社会信用代码
export function validOrgNum(value) {
  return (
    /^[0-9A-Z]+$/.test(value) &&
    value.length === 18 &&
    /^[^_IOZSV\W]{2}\d{6}[^_IOZSV\W]{10}$/g.test(value)
  )
}
/**
 *  银行卡号校验
 */
// 银行卡号Luhn校验算法
// luhn校验规则：16位银行卡号（19位通用）:
// 1.将未带校验位的 15（或18）位卡号从右依次编号 1 到 15（18），位于奇数位号上的数字乘以 2。
// 2.将奇位乘积的个十位全部相加，再加上所有偶数位上的数字。
// 3.将加法和加上校验位能被 10 整除。

// bankno为银行卡号
export function luhnCheck(bankno) {
  const lastNum = bankno.substr(bankno.length - 1, 1) // 取出最后一位（与luhm进行比较）

  const first15Num = bankno.substr(0, bankno.length - 1) // 前15或18位
  const newArr = []
  for (let i = first15Num.length - 1; i > -1; i--) {
    // 前15或18位倒序存进数组
    newArr.push(first15Num.substr(i, 1))
  }
  const arrJiShu = [] // 奇数位*2的积 <9
  const arrJiShu2 = [] // 奇数位*2的积 >9

  const arrOuShu = [] // 偶数位数组
  for (let j = 0; j < newArr.length; j++) {
    if ((j + 1) % 2 === 1) {
      // 奇数位
      if (parseInt(newArr[j]) * 2 < 9) {
        arrJiShu.push(parseInt(newArr[j]) * 2)
      } else {
        arrJiShu2.push(parseInt(newArr[j]) * 2)
      }
    } else {
      // 偶数位
      arrOuShu.push(newArr[j])
    }
  }

  const jishu_child1 = [] // 奇数位*2 >9 的分割之后的数组个位数
  const jishu_child2 = [] // 奇数位*2 >9 的分割之后的数组十位数
  for (let h = 0; h < arrJiShu2.length; h++) {
    jishu_child1.push(parseInt(arrJiShu2[h]) % 10)
    jishu_child2.push(parseInt(arrJiShu2[h]) / 10)
  }

  let sumJiShu = 0 // 奇数位*2 < 9 的数组之和
  let sumOuShu = 0 // 偶数位数组之和
  let sumJiShuChild1 = 0 // 奇数位*2 >9 的分割之后的数组个位数之和
  let sumJiShuChild2 = 0 // 奇数位*2 >9 的分割之后的数组十位数之和
  for (let m = 0; m < arrJiShu.length; m++) {
    sumJiShu = sumJiShu + parseInt(arrJiShu[m])
  }

  for (let n = 0; n < arrOuShu.length; n++) {
    sumOuShu = sumOuShu + parseInt(arrOuShu[n])
  }

  for (let p = 0; p < jishu_child1.length; p++) {
    sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p])
    sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p])
  }
  // 计算总和
  const sumTotal =
    parseInt(sumJiShu) +
    parseInt(sumOuShu) +
    parseInt(sumJiShuChild1) +
    parseInt(sumJiShuChild2)

  // 计算Luhm值
  const k = parseInt(sumTotal) % 10 === 0 ? 10 : parseInt(sumTotal) % 10
  const luhm = 10 - k

  if (parseInt(lastNum) === luhm && lastNum.length !== 0) {
    console.log('Luhm验证通过')
    return true
  } else {
    console.log('银行卡号必须符合Luhm校验')
    return false
  }
}

// 检查银行卡号
// bankno: 银行卡号, canNull: 为空不校验
export function CheckBankNo(bankno) {
  bankno = bankno || '' // 防止出现 null
  bankno = bankno.replace(/\s/g, '')
  if (bankno === '') {
    return '请填写银行卡号'
  }
  if (bankno.length < 16 || bankno.length > 19) {
    return '银行卡号应该在16~19位之间'
  }
  const num = /^\d*$/ // 全数字
  if (!num.exec(bankno)) {
    return '银行卡号应该为全数字'
  }
  // 开头6位
  const strBin =
    '10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99'
  if (strBin.indexOf(bankno.substring(0, 2)) === -1) {
    return '银行卡号前6位不符合规则'
  }
  // Luhn校验
  if (!luhnCheck(bankno)) {
    return '请填写正确的银行卡号'
  }
  return true
}
